import React from 'react';
import { useApp } from '../context/AppContext';

interface TwoColumnLayoutPropsBase {
  title?: string;
  subtitle?: string;
  aside: React.ReactNode;
  prepend?: React.ReactNode;
  tags?: React.ReactNode[];
}

export type TwoColumnLayoutProps = TwoColumnLayoutPropsBase & React.HTMLAttributes<HTMLDivElement>;

const TwoColumnLayout = React.forwardRef<HTMLDivElement, TwoColumnLayoutProps>((props, ref) => {
  const {
    className: propClasses,
    title,
    subtitle,
    children,
    aside,
    prepend,
    tags,
    ...rest
  } = props;
  const { dynamicConstants } = useApp();
  const { isMobile } = dynamicConstants;

  const classes = ['p-6 bg-white'];
  if (propClasses) classes.push(propClasses);

  return (
    <div ref={ref} className={classes.join(' ')} {...rest}>
      <div className="grid grid-cols-1 gap-6">
        <div>
          {(tags ?? []).length > 0 ? (
            <div className="flex flex-wrap gap-1 mb-1 go-event-zones">{tags}</div>
          ) : null}
          {title && <div className="font-bold">{title}</div>}
          {subtitle && <div className="text-2xl font-bold text-accent">{subtitle}</div>}
        </div>
        {prepend}
        <div className={`flex gap-6 flex-col ${!isMobile ? 'lg:flex-row lg:items-start' : ''}`}>
          <div className="flex-grow grid grid-cols-1 gap-4">{children}</div>
          <div className="flex-grow flex-basis-400 sticky top-4">
            {isMobile && <hr className="border border-border mb-6" />}
            {aside}
          </div>
        </div>
      </div>
    </div>
  );
});

export default TwoColumnLayout;
